import React, { useState, useEffect, Fragment } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import '../../../index.css';

import timeIcon from '../../../../../../../assets/images/atendimentohumano.svg';
import ContainerReport from '../../../../ContainerReport';
import { getAttendanceTime } from '../../../../../../../store/actions/reports';
import { AddDays } from './UtilAddDays';

const ATTENDANCE_TIME_INITIAL_DATA = {
  average: '00:00:00',
  min: '00:00:00',
  max: '00:00:00',
};

/**
 * Component for show the bot attendance time report
 *
 * @param {*} props
 * @returns
 */
const AttendanceTimeReportBot = (props) => {
  const {
    match,
    user,
    getAttendanceTime,
    attendance,
    componentData,
    humanAttendanceTime,
    bot,
  } = props;

  const {
    parentFilter,
    draggableId,
    onRemoveClick,
    isEditMode,
  } = componentData;

  const { botid } = match.params;
  const { startDate, endDate } = parentFilter;
  const token = user.dashboard_token;

  const [attendanceTime, setAttendanceTime] = useState(
    ATTENDANCE_TIME_INITIAL_DATA
  );
  const [timezone, setTimezone] = useState('');

  useEffect(() => {
    if (bot && bot.settings && bot.settings.timezone) {
      setTimezone(bot.settings.timezone.fuso);
    }
  }, [bot]);

  useEffect(() => {
    if (user && timezone !== '') {
      const { nameTags, channels, variables } = parentFilter;
      getAttendanceTime(botid, token, {
        startDate,
        endDate,
        tags: nameTags,
        channels,
        variables,
        timezone,
      });
    }
  }, [parentFilter, user, timezone]);

  const renderContainerContent = () => {
    return (
      <Fragment>
        <div className="container-dados-relatorio">
          <p className="result-relatorio-yellow">
            {AddDays(humanAttendanceTime?.human?.min || 0)}
            {moment
              .utc(
                moment
                  .duration(humanAttendanceTime?.human?.min || 0)
                  .asMilliseconds()
              )
              .format('HH:mm:ss')}
          </p>
          <span className="tipo-relatorio">Tempo Mínimo</span>
        </div>
        <div className="divider-info-relatorio" />
        <div className="container-dados-relatorio">
          <p className="result-relatorio-yellow">
            {AddDays(humanAttendanceTime?.human?.avg || 0)}
            {moment
              .utc(
                moment
                  .duration(humanAttendanceTime?.human?.avg)
                  .asMilliseconds()
              )
              .format('HH:mm:ss')}
          </p>
          <span className="tipo-relatorio">Média</span>
        </div>
        <div className="divider-info-relatorio" />
        <div className="container-dados-relatorio">
          <p className="result-relatorio-yellow">
            {AddDays(humanAttendanceTime?.human?.max || 0)}
            {moment
              .utc(
                moment
                  .duration(humanAttendanceTime?.human?.max || 0)
                  .asMilliseconds()
              )
              .format('HH:mm:ss')}
          </p>
          <span className="tipo-relatorio">Tempo Máximo</span>
        </div>
      </Fragment>
    );
  };

  return (
    <ContainerReport
      type="absolute"
      icon={timeIcon}
      title="Tempo de Atendimento HUMANO"
      containerContent={renderContainerContent()}
      draggableId={draggableId}
      onRemoveClick={onRemoveClick}
      isEditMode={isEditMode}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.users.signedUser,
    humanAttendanceTime: state.reports.attendanceTime,
    bot: state.bots.bot,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ getAttendanceTime }, dispatch);
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AttendanceTimeReportBot)
);
